import { useState } from "react";
import { db } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { useAuth } from "../context/AuthContext";
import { THEME_COLOR } from "../config/club";

export default function AdminCreateSession({ clubId, ToastShow }) {
  const { user } = useAuth();
  const [name, setName] = useState("");
  const [startAt, setStartAt] = useState("");
  const [endAt, setEndAt] = useState("");
  const [rateType, setRateType] = useState("per_game");
  const [rate, setRate] = useState("");
  const [loading, setLoading] = useState(false);

  const themeAlpha = (opacity) => `${THEME_COLOR}${opacity}`;

  const createSession = async () => {
  if (!name || !startAt || !endAt || !rate) {
    ToastShow("error", "Complete all fields");
    return;
  }

  setLoading(true);

  try {
    await addDoc(collection(db, "clubs", clubId, "sessions"), {
      name,
      startAt: new Date(startAt),
      endAt: new Date(endAt),
      rateType,
      rate: Number(rate),
      status: "active",
      createdBy: user.uid,
      createdAt: serverTimestamp(),
    });

    // reset form
    setName("");
    setStartAt("");
    setEndAt("");
    setRate("");

    ToastShow("success", "Session created & activated");

  } catch (error) {
    console.error("Create session error:", error);
    ToastShow("error", "Failed to create session");
  } finally {
    setLoading(false); // 🔥 always runs
  }
};

 const inputStyle = {
  borderRadius: "12px",
  padding: "12px 16px",
  border: "1px solid var(--border-color)",
  fontSize: "0.95rem",
  transition: "all 0.2s ease",
  background: "var(--surface-bg)",
  color: "var(--text-color)"
};

  return (
    <div className="p-1">
      <h5 className="fw-bold mb-4" style={{ color: "var(--text-color)", letterSpacing: "-0.5px" }}>
        New Session Details
      </h5>

      <div className="row g-3">
        {/* Session Name */}
        <div className="col-12">
          <label className="small fw-bold text-muted mb-1 ms-1">SESSION NAME</label>
          <input
            style={inputStyle}
            className="form-control custom-input"
            placeholder="e.g. RRC Weekend Game"
            value={name}
            onChange={e => setName(e.target.value)}
          />
        </div>

        {/* Date Row - Two columns on iPad/Laptop */}
        <div className="col-md-6">
          <label className="small fw-bold text-muted mb-1 ms-1">START DATE & TIME</label>
          <input
            type="datetime-local"
            style={inputStyle}
            className="form-control custom-input"
            value={startAt}
            onChange={e => setStartAt(e.target.value)}
          />
        </div>

        <div className="col-md-6">
          <label className="small fw-bold text-muted mb-1 ms-1">END DATE & TIME</label>
          <input
            type="datetime-local"
            style={inputStyle}
            className="form-control custom-input"
            value={endAt}
            onChange={e => setEndAt(e.target.value)}
          />
        </div>

        {/* Rate Section */}
        <div className="col-md-7">
          <label className="small fw-bold text-muted mb-1 ms-1">PRICING MODEL</label>
          <select
            style={inputStyle}
            className="form-select custom-input"
            value={rateType}
            onChange={e => setRateType(e.target.value)}
          >
            <option value="per_game">Per Game</option>
            <option value="fixed">Fixed Rate</option>
          </select>
        </div>

        <div className="col-md-5">
          <label className="small fw-bold text-muted mb-1 ms-1">AMOUNT</label>
          <div className="input-group">
            <span
              className="input-group-text border-0 bg-transparent ps-0 fw-bold"
              style={{ color: "var(--brand-color)" }}
            >PHP</span>
            <input
              type="number"
              style={inputStyle}
              className="form-control custom-input"
              placeholder="0.00"
              value={rate}
              onChange={e => setRate(e.target.value)}
            />
          </div>
        </div>

        <div className="col-12 mt-4">
          <button 
            className="btn w-100 py-3 rounded-4 fw-bold shadow-sm" 
            style={{ 
              backgroundColor: THEME_COLOR, 
              color: 'white',
              fontSize: '1rem'
            }}
            onClick={createSession}
            disabled={loading}
          >
            {loading ? 'Creating session...':'Activate Session Now'}
          </button>
        </div>
      </div>

      <style>{`
        .custom-input:focus {
  background: var(--card-bg) !important;
  border-color: ${THEME_COLOR} !important;
  box-shadow: 0 0 0 4px ${themeAlpha('15')} !important;
  color: var(--text-color) !important;
}
        label {
          font-size: 0.7rem;
          letter-spacing: 0.5px;
        }
          .custom-input::placeholder {
  color: var(--text-muted);
}
      `}</style>
    </div>
  );
}